import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CssThemesService {

  constructor(
    @Inject(DOCUMENT) private document: Document
  ) { }

  loadStyle() {
    const head = this.document.getElementsByTagName('head')[0];

    let themeLink = this.document.getElementById('client-theme') as HTMLLinkElement;
    if (themeLink) {
      themeLink.href = 'tupss.css';
    } else {
      const style = this.document.createElement('link');
      style.id = 'client-theme';
      style.rel = 'stylesheet';
      style.href = 'tupss.css';
      head.appendChild(style);
    }
  }

  loadMyChoiceStyle() {
    const head = this.document.getElementsByTagName('head')[0];

    let themeLink = this.document.getElementById('client-theme') as HTMLLinkElement;
    if (themeLink) {
      themeLink.href = 'my-choice.css';
    } else {
      const style = this.document.createElement('link');
      style.id = 'client-theme';
      style.rel = 'stylesheet';
      style.href = 'my-choice.css';
      head.appendChild(style);
    }
  }

  loadCustomizedClaimsStyle(flowType: string) {
    const head = this.document.getElementsByTagName('head')[0];
    let themeLink = this.document.getElementById('client-theme') as HTMLLinkElement;
    
    // Determine the correct CSS file based on flowType
    let cssFile = 'customized-claims-portal.css';
    if (flowType === 'customized-claims-portal') {
      cssFile = 'customized-claims-portal.css';
    } else if (flowType === 'ajg') {
      cssFile = 'ajg.css';
    } else if (flowType === 'inxpress') {
      cssFile = 'inxpress.css';
    } else if (flowType === 'pirateship') {
      cssFile = 'pirateship.css';
    } else {
      cssFile = 'dynamic.css';
    }
    
    if (themeLink) {
      themeLink.href = cssFile;
    } else {
      const style = this.document.createElement('link');
      style.id = 'client-theme';
      style.rel = 'stylesheet'; 
      style.href = cssFile;
      head.appendChild(style);
    }
  } 
  
  loadSspStyle() {
    const head = this.document.getElementsByTagName('head')[0];
    const style = this.document.createElement('link');
    style.id = 'client-theme';
    style.rel = 'stylesheet'; 
    style.href = 'self-service-portal.css';
    head.appendChild(style);
  }

  loadHappyReturnsStyle() {
    const head = this.document.getElementsByTagName('head')[0];
    const style = this.document.createElement('link');
    style.id = 'client-theme';
    style.rel = 'stylesheet'; 
    style.href = 'happy-returns.css';
    head.appendChild(style);
  }
}
